import React, { useState } from "react";
import CovidRiskCheckerService from 'services/covid-risk-checker.service';
import AuthService from 'services/auth.service';
import CovidRiskCheckerSelectedSymptoms from './CovidRiskCheckerSelectedSymptoms';
import { Modal } from "react-bootstrap";
import CloseBtn from 'assets/icons/Close.svg';
import Spinner from 'react-bootstrap/Spinner';

function CovidRiskCheckerSubmitConfirmModal({setShowSymptomsConfirm, showSymptomsConfirm, symptoms, setCertified, chatId}) {
  const [submitting, setSubmitting] = useState(false); 

  const submitCovid = () => {
    setSubmitting(true);
    const params = {
      covid_symptoms: symptoms
    }
    CovidRiskCheckerService.submitCovid(chatId, params).then(
      (data) => {
        setSubmitting(false);
        setCertified(true)
      },
      (error) => {
        setSubmitting(false);
        if (error.response.status === 401) {
          AuthService.logout();
          window.location.replace('/eb/login');
        }
        if (error.response?.data?.error) {
          alert(error.response?.data?.error);
        }
        if (error.response?.data?.errors) {
          alert(error.response?.data?.errors[0]);
        }
      }
    );
  }

  return (
    <Modal className="covid-symptoms-confirmation-modal" size="lg" show={showSymptomsConfirm} onHide={() => {setShowSymptomsConfirm(false)}} backdrop="static" keyboard={false}>
      <Modal.Header>
        <button type="button" className="close" onClick={() => {setShowSymptomsConfirm(false)}}>
            <img src={ CloseBtn } alt="modal-close" />
        </button>
      </Modal.Header>
      <Modal.Body>
        <h6>Confirmation</h6>
        <p>Please note that the following symptom(s) are selected correctly. You will not be able to make changes once you have submitted.</p>
        <CovidRiskCheckerSelectedSymptoms symptoms={symptoms} />
      </Modal.Body>
      <Modal.Footer>
        <div className="w-100 d-flex justify-content-end">
          <div>
            {submitting ? <Spinner animation="border" className="spinner"/> : <button className="btn btn-danger" onClick={submitCovid}>Confirm & Send</button> }
          </div>
        </div>
      </Modal.Footer>
    </Modal>
  );
}

export default CovidRiskCheckerSubmitConfirmModal;
